import { render, staticRenderFns } from "./StaffPictures.vue?vue&type=template&id=3f0c2463&scoped=true"
import script from "./StaffPictures.vue?vue&type=script&lang=js"
export * from "./StaffPictures.vue?vue&type=script&lang=js"
import style0 from "./StaffPictures.vue?vue&type=style&index=0&id=3f0c2463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0c2463",
  null
  
)

export default component.exports